/**
 *
 * ReleasePage
 *
 */

import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Switch, Route } from 'react-router';

// resolve
import { useResourceUpdateParams } from 'lib/domonda-resource/react';

// modules
import { useReleaseOverviewQueryParams, releasableOverviewResource } from 'modules/ReleaseOverview';

// parts
import { ReleaseOverviewPage } from './ReleaseOverviewPage';

export type ReleasePageProps = RouteComponentProps;

export const ReleasePage: React.FC<ReleasePageProps> = (props) => {
  const { match } = props;

  const [params] = useReleaseOverviewQueryParams({ onPathname: match.url });
  useResourceUpdateParams(releasableOverviewResource, params);

  return (
    <Switch>
      <Route path={match.path} component={ReleaseOverviewPage} />
    </Switch>
  );
};
